var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch-img"},_vm._l((_vm.images),function(item,index){return _c('img',{key:index,class:{show: index === _vm.currentIndex},attrs:{"src":item,"alt":"imgaes"}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }